import React, { type JSX } from 'react';

import HelmetWrapper from 'components/atoms/HelmetWrapper';
import PageHeaderPusher from 'components/atoms/PageHeaderPusher';
import DefaultPageHeader from 'components/composites/DefaultPageHeader';
import FarmbotIcon from 'components/icons/FarmbotIcon';

import './styles.less';

interface Props {
  helmetSection: string;
  title: string;
  extra?: JSX.Element;
}

export default function SystemNoticePage({
  helmetSection,
  title,
  extra
}: Props): JSX.Element {
  return (
    <>
      <HelmetWrapper section={helmetSection} />
      <DefaultPageHeader title="" />
      <PageHeaderPusher>
        <div className="SystemNoticePage">
          <FarmbotIcon style={{ height: 52 }} />
          <div className="SystemNoticePage-title">{title}</div>
          {extra}
        </div>
      </PageHeaderPusher>
    </>
  );
}
